/**
 * Утилита для безопасного использования View Transition API
 * 
 * View Transition API поддерживается только в современных браузерах:
 * - Chrome 111+, Edge 111+, Opera 97+
 * - Не поддерживается в старых браузерах (Chrome < 111, Firefox, Safari < 18.1)
 * 
 * Эта функция проверяет поддержку API перед использованием,
 * что предотвращает ошибки в старых браузерах.
 */

/**
 * Безопасно запускает View Transition, если API поддерживается
 * Если API не поддерживается, просто выполняет callback синхронно
 * 
 * @param {Function} callback - Функция, которую нужно выполнить внутри transition
 * @returns {Promise|void} - Promise если transition поддерживается, иначе void
 */
export function safeStartViewTransition(callback) {
    // Проверяем поддержку View Transition API
    if (document.startViewTransition && typeof document.startViewTransition === 'function') {
        // API поддерживается - используем его
        return document.startViewTransition(callback);
    } else {
        // API не поддерживается - просто выполняем callback
        if (typeof callback === 'function') {
            callback();
        }
    }
}

/**
 * Проверяет, поддерживается ли View Transition API в текущем браузере
 * 
 * @returns {boolean} - true если API поддерживается, false иначе
 */
export function isViewTransitionSupported() {
    return !!(document.startViewTransition && typeof document.startViewTransition === 'function');
}
